import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Badge,
  Button,
  Spinner,
  ButtonGroup,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axiosInstance from "../../helpers/axiosInstance";

const ContactUs = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("all");

  useEffect(() => {
    fetchContacts();
  }, [selectedStatus]);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/v1/contactus");
      const filteredContacts =
        selectedStatus === "all"
          ? response.data
          : response.data.filter((contact) => contact.status === selectedStatus);
      setContacts(filteredContacts);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (id, newStatus) => {
    try {
      await axiosInstance.put(`/api/v1/contactus/${id}/status`, { status: newStatus });
      fetchContacts();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Contact Requests"
          breadcrumbItems={[
            { title: "Dashboard", link: "/dashboard" },
            { title: "Contact Requests", link: "/contact-us" },
          ]}
        />

        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h4 className="card-title mb-0">Contact Requests</h4>
                  </div>
                  <ButtonGroup>
                    <Button
                      color={selectedStatus === "all" ? "primary" : "light"}
                      onClick={() => setSelectedStatus("all")}
                    >
                      All
                    </Button>
                    <Button
                      color={selectedStatus === "pending" ? "primary" : "light"}
                      onClick={() => setSelectedStatus("pending")}
                    >
                      Pending
                    </Button>
                    <Button
                      color={selectedStatus === "responded" ? "primary" : "light"}
                      onClick={() => setSelectedStatus("responded")}
                    >
                      Responded
                    </Button>
                    <Button
                      color={selectedStatus === "closed" ? "primary" : "light"}
                      onClick={() => setSelectedStatus("closed")}
                    >
                      Closed
                    </Button>
                  </ButtonGroup>
                </div>

                {loading ? (
                  <div className="text-center my-5">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Message</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contacts.map((contact) => (
                          <tr key={contact._id}>
                            <td>{contact.name}</td>
                            <td>{contact.email}</td>
                            <td>{contact.phone}</td>
                            <td>
                              <div style={{ maxWidth: "200px" }} className="text-truncate">
                                {contact.message}
                              </div>
                            </td>
                            <td>
                              <Badge
                                color={
                                  contact.status === "pending"
                                    ? "warning"
                                    : contact.status === "responded"
                                    ? "info"
                                    : "success"
                                }
                              >
                                {contact.status}
                              </Badge>
                            </td>
                            <td>
                              {new Date(contact.createdAt).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                <Button
                                  color="info"
                                  size="sm"
                                  onClick={() => handleStatusUpdate(contact._id, "responded")}
                                  disabled={contact.status === "responded"}
                                >
                                  Mark Responded
                                </Button>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleStatusUpdate(contact._id, "closed")}
                                  disabled={contact.status === "closed"}
                                >
                                  Close
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;
